import React, { ReactElement } from 'react';
import { IHomeIconProps } from './types';
import { SCSvgPath, SCSvgRoot, SCSvgWrapper } from './styles';

const HomeIcon = ({ iconState, disabled }: IHomeIconProps): ReactElement => {
    return (
        <SCSvgWrapper
            data-testid={'home_icon'}
            aria-disabled={disabled ? 'true' : 'false'}
            role="img"
            aria-label="Home icon"
        >
            <SCSvgRoot
                aria-labelledby="Home icon"
                role="group"
                width="100%"
                height="100%"
                viewBox="0 0 21 22"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlSpace="preserve"
            >
                <SCSvgPath
                    animate={iconState}
                    data-testid={iconState ? 'HomeIconActive' : 'HomeIconInactive'}
                    disabled={disabled}
                    d="M7.8125 21.0938V15.6167C7.8125 15.2344 8.20312 14.8438 8.59375 14.8438H11.7188C12.1094 14.8438 12.5 15.2344 12.5 15.625V21.0938C12.5 21.5252 12.8498 21.875 13.2812 21.875H19.5312C19.9627 21.875 20.3125 21.5252 20.3125 21.0938V10.1562C20.3125 9.94905 20.2302 9.75034 20.0837 9.60382L17.9688 7.4889V2.34375C17.9688 1.91228 17.619 1.5625 17.1875 1.5625H15.625C15.1935 1.5625 14.8438 1.91228 14.8438 2.34375V4.3639L10.7087 0.228823C10.4036 -0.0762743 9.90892 -0.0762743 9.60382 0.228823L0.228823 9.60382C0.08231 9.75034 0 9.94905 0 10.1562V21.0938C0 21.5252 0.349778 21.875 0.78125 21.875H7.03125C7.46272 21.875 7.8125 21.5252 7.8125 21.0938Z"
                />
            </SCSvgRoot>
        </SCSvgWrapper>
    );
};

export { HomeIcon };
